/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const FAILED_INV_VAL = 'boilderplate/FailedInvoice/FAILED_INV_VAL'
export const RESET_FETCH_FAILED = 'boilerplate/FailedInvoice/RESET_FETCH_FAILED'
export const ON_NOTIFY = 'boilerplate/FailedInvoice/ON_NOTIFY'
export const LOADER_STATUS = 'boilerplate/FailerInvoice/LOADER_STATUS'
export const TOTAL_RECORD = 'boilerplate/FailedInvoice/TOTAL_RECORD'
export const GET_ITEM = 'boilderplate/FailedInvoice/GET_ITEM'
export const TOTAL_ITEM_RECORDS = 'boilderplate/FailedInvoice/TOTAL_ITEM_RECORDS'
export const TXN_RECORD = 'biolderplate/FailedInvoice/TXN_RECORD'
export const SET_PAGE_PAGE = 'boilerplate/FailedInvoices/SET_PAGE_PAGE'
export const SET_ITEMS_ERROR = 'boilerplate/FailedInvoices/SET_ITEMS_ERROR'
